import { render } from "./TransitionOverlay.vue?vue&type=template&id=87012a38&scoped=true"
import script from "./TransitionOverlay.vue?vue&type=script&lang=js"
export * from "./TransitionOverlay.vue?vue&type=script&lang=js"

import "./TransitionOverlay.vue?vue&type=style&index=0&id=87012a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87012a38"]])

export default __exports__